import React, { useState } from "react";
import EditModal from "./EditModal";
import DeleteModal from "./DeleteModal";
import HistoryActionsMenu from "./Menu";

interface Props {
  isShowMenu: boolean;
  chatTitle: string;
  onCloseMenu: () => void;
  onChatTitleEdit: (newTitle: string) => void;
  onChatDelete: () => void;
  onBlur?: () => void;
}

const HistoryActions: React.FC<Props> = ({
  isShowMenu,
  chatTitle,
  onCloseMenu,
  onChatTitleEdit,
  onChatDelete,
  onBlur
}) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  return (
    <>
      <HistoryActionsMenu
        isShowMenu={isShowMenu}
        onCloseMenu={onCloseMenu}
        onRequestEdit={() => setEditModalOpen(true)}
        onRequestDelete={() => setDeleteModalOpen(true)}
        onBlur={onBlur}
      />
      <EditModal
        isOpen={editModalOpen}
        defaultTitle={chatTitle}
        onClose={() => setEditModalOpen(false)}
        onChatTitleEdit={onChatTitleEdit}
      />
      <DeleteModal
        isOpen={deleteModalOpen}
        chatTitle={chatTitle}
        onClose={() => setDeleteModalOpen(false)}
        onChatDelete={onChatDelete}
      />
    </>
  );
};

export default HistoryActions;
